<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><span>CONTENTS</span></p>
<p class="toc"><a href="#/books#c01k" id="c1k">The Books of the Torah</a></p>
<p class="toc"><a href="#/tot#c02k" id="c2k">Timeline of the Torah and Judaic History</a></p>
<p class="toc"><a href="#/intro#c03k" id="c3k">Introduction</a></p>
<p class="toc"><a href="#/image#c04k" id="c4k">Image Gallery</a></p>
<p class="toc"><a href="#/chapter1#c01" id="c1">A Note to the Reader</a></p>
<p class="toc"><a href="#/chapter2#c02" id="c2">The Men Behind the Book</a></p>
<p class="toc"><a href="#/chapter3#c03" id="c3">From the Books of Moses</a></p>
<p class="toc"><span href="#/chapter4#c04" id="c4" title="Link target outside of Sample">The Ballad of Job</span></p>
<p class="toc"><span href="#/chapter5#c05" id="c5" title="Link target outside of Sample">Poems of King David</span></p>
<p class="toc"><span href="#/chapter6#c06" id="c6" title="Link target outside of Sample">Parables of King Solomon</span></p>
<p class="toc"><span href="#/chapter7#c07" id="c7" title="Link target outside of Sample">Solomon's Elegy on Vanity</span></p>
<p class="toc"><span href="#/chapter8#c08" id="c8" title="Link target outside of Sample">The Vision of Isaiah</span></p>
<p class="toc"><span href="#/chapter9#c09" id="c9" title="Link target outside of Sample">The Lament of Jeremiah</span></p>
<p class="toc"><span href="#/chapter10#c010" id="c10" title="Link target outside of Sample">Ethics of King Solomon</span></p>
<p class="toc"><span href="#/chapter11#c011" id="c11" title="Link target outside of Sample">Aphorisms of Jeshu ben Sirah</span></p>
<p class="toc"><span href="#/chapter12#c012" id="c12" title="Link target outside of Sample">The Love Songs of King Solomon</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5961ddd3